import {
    useEffect,
    useState
} from "react";
import {EmailAddressForm} from "../forms/EmailAddressForm.tsx";
import {useWindowScroll} from "@mantine/hooks";
import {LinkToSignUpPage} from "../../sign-up/components/LinkToSignUpPage.tsx";
import {LinkToResetPasswordPage} from "../../reset-password/components/LinkToResetPasswordPage.tsx";
import {SignInPageGrid} from "../components/SignInPageGrid.tsx";
import {useAuth} from "../../../../hooks/useAuth.ts";
import {Navigate} from "react-router-dom";
import {Cache} from "aws-amplify/utils";
import {PlatformLoader} from "@flexinet/ui-components";
import {useUserAccount} from "../../../../hooks/useUserAccount.ts";
import {isAllowedRedirectUrl} from "../../../../utils/isAllowedRedirectUrl.ts";

export const IndexPage = () => {

    const [destination, setDestination] = useState('')

    const [, scrollTo] = useWindowScroll();

    const {
        user,
        idToken,
        accessToken,
    } = useAuth()

    const {userAccount} = useUserAccount()

    const redirectAuthenticated = async () => {

        const authorization = await Cache.getItem('authorization')

        if (typeof user !== 'undefined' && typeof idToken !== 'undefined' && typeof accessToken !== 'undefined') {

            // FNP-864: the cache is UNTRUSTED input here. It is written before
            // the user authenticates, so a signed-out visitor following a
            // crafted link can seed it with an arbitrary origin. Re-validate
            // against the allowlist immediately before emitting tokens.
            if (authorization && isAllowedRedirectUrl(authorization.redirectUrl)) {

                // Never log this URL — it carries both raw tokens.
                const returnUrl = `${authorization.redirectUrl}#id_token=${idToken}&access_token=${accessToken}&token_type=Bearer&expires_in=3600&state=${authorization.state}`
                setDestination(returnUrl)
                await Cache.removeItem('authorization')

            } else {

                // Fail closed: drop anything unrecognised and go to the dashboard.
                await Cache.removeItem('authorization')
                setDestination('dashboard')

            }
        }
    }


    useEffect(() => {
        redirectAuthenticated()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, idToken, accessToken])


    useEffect(() => {
        scrollTo({y: 0})
    }, [scrollTo]);

    // if (typeof user !== 'undefined' && typeof idToken !== 'undefined' && typeof accessToken !== 'undefined') {
    if (userAccount) {
        // navigate('/dashboard')

        if (destination === '') {
            return <PlatformLoader/>
        } else {
            if (destination === 'dashboard') {
                return <Navigate to={'/dashboard'}/>
            } else {
                window.location.assign(destination)
            }
        }

    } else {

        return (
            <SignInPageGrid>
                <EmailAddressForm/>
                <LinkToSignUpPage/>
                <LinkToResetPasswordPage/>
            </SignInPageGrid>
        );

    }
}
